import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import { aboutUs } from "../../../Utils/Apis";

export const useAboutUs = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { post } = useMainContext();
  const getData = async () => {
    setLoading(true);
    const { data, status } = await post(aboutUs);
    if (+status == 200) {
      setData(data);
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return { loading, data };
};
